<template>
  <v-app style="background-color: #eef2f7">
    <notifications></notifications>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Drawer from "./layouts/NavigationDrawer/Index.vue";
import Notification from "./components/notify/Notification.vue";

export default {
  name: "App",

  methods: {
    getRoles() {
      let roles =
        this.$keycloak.tokenParsed.resource_access["rpa-painel-administrativo"]
          ?.roles || "";
      localStorage.setItem("roles", JSON.stringify(roles));
    },
  },

  created() {
    this.getRoles();
  },
};
</script>

<style>
@import "./assets/style/style.css";
</style>
